import heartBeatPageTools from '~/common/heartBeatPageTools';

class AppMountedWrapper {
  private visibilitychangeSum = 0;

  install() {
    let { visibilitychangeSum } = this;
    // 监听页面显示或者影藏
    document.addEventListener('visibilitychange', () => {
      const string = document.visibilityState;
      if (string === 'hidden' && visibilitychangeSum > 0) {
        heartBeatPageTools.stop();
      }
      if (string === 'visible') {
        // 当页面由隐藏至显示时
        heartBeatPageTools.start();
      }
      visibilitychangeSum++;
    });

    // 心跳启动
    heartBeatPageTools.start(true);
  }
}

export default AppMountedWrapper;
